/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable unicorn/prefer-query-selector */
import { Box } from "@mui/material";
import { LocationForm } from "../../Components";
import useViewModel from "./ViewModel";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FormState, UserInterfaceState } from "../../../../shared/Enum";
import LoadingBackdrop from "../../../../shared/Components/LoadingBackdrop";
import PageContentHeader from "../../../../shared/Components/PageContentHeader";
import { enqueueSnackbar } from "notistack";

export function EditLocationPage() {
  const { data, method } = useViewModel();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      method.onGetLocationDetail(id);
    } else {
      navigate("/master-location");
    }
  }, []);

  useEffect(() => {
    if (FormState.isSuccess(data.formState)) {
      navigate("/master-location");
    } else if (FormState.isError(data.formState)) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.formState]);

  useEffect(() => {
    if (UserInterfaceState.isError(data.uiState)) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.uiState]);

  return (
    <Box className="flex flex-col w-full p-5">
      <PageContentHeader label="Edit Location" />
      <LocationForm
        onSubmit={method.onUpdateLocation}
        defaultValue={data.locationDetail}
      />
      <LoadingBackdrop
        isOpen={
          FormState.isLoading(data.formState) ||
          UserInterfaceState.isLoading(data.uiState)
        }
      />
    </Box>
  );
}
